// extracted by css-extract-rspack-plugin
export default {"content":"wJGKC7KfMp8IOvH7","subContent":"Tca_XV58rCEEF6pJ","ringAndQuadrant":"sVtktdeA5sgVm8z9","layout":"HM_ThFBwBHItv8pz","sidebar":"NKYqwjdr4chPghp4","back":"DlCJ23Itm8Q25JEX"};